/**
 * Camada central de configuração de provedores (pedido explícito do
 * documento da segunda API). Cada entrada aqui é uma competição real,
 * com ID e temporada CONFIRMADOS via /api/debug/lookup-competitions
 * (nunca inventados). O resto do app nunca precisa saber que essas
 * competições vêm de uma API diferente — só verifica se o
 * `competitionId` está aqui pra decidir qual repositório usar
 * (CompositeMatchRepository/CompositeCompetitionRepository).
 *
 * `enabled: false` = existe no código, mas não aparece pro usuário nem é
 * sincronizada — usado pra Copa do Brasil até confirmarmos que ela não
 * duplica com o que já vem do football-data.org (a API atual já pode
 * cobrir isso, dependendo do plano da chave).
 */
export interface ApiFootballCompetitionConfig {
  /** Usado como `competitionId` no resto do app — precisa ser único e
   * nunca colidir com os códigos curtos do football-data.org (ex: "BSA"). */
  competitionId: string;
  apiFootballLeagueId: number;
  apiFootballSeason: number;
  name: string;
  country: string;
  type: "League" | "Cup";
  enabled: boolean;
}

export const API_FOOTBALL_COMPETITIONS: ApiFootballCompetitionConfig[] = [
  {
    competitionId: "PAULISTA_A1",
    apiFootballLeagueId: 475,
    apiFootballSeason: 2026,
    name: "Campeonato Paulista - A1",
    country: "Brasil",
    type: "League",
    enabled: true,
  },
  {
    competitionId: "COPA_DO_BRASIL",
    apiFootballLeagueId: 73,
    apiFootballSeason: 2026,
    name: "Copa do Brasil",
    country: "Brasil",
    type: "Cup",
    enabled: true, // confirmado pelo usuário: não aparece via football-data.org, sem risco de duplicar
  },
];

export function findApiFootballCompetition(competitionId: string): ApiFootballCompetitionConfig | undefined {
  return API_FOOTBALL_COMPETITIONS.find((c) => c.competitionId === competitionId && c.enabled);
}

export function isApiFootballCompetition(competitionId: string): boolean {
  return findApiFootballCompetition(competitionId) !== undefined;
}
